import styled from 'styled-components';

import titleStyles from '../styled';

import DateTitle from './container';

export default styled(DateTitle)`
  ${titleStyles}
`;
